import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar, Tag } from "lucide-react";
import api from "@/lib/api";
import { formatDate } from "@/lib/helpers";

export default function EdukasiDetail() {
  const { id } = useParams();
  const [e, setE] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); api.get(`/education/${id}`).then((r) => setE(r.data)).catch(() => setE(false)); }, [id]);

  if (e === false) return <div className="container-page py-24 text-center text-slate-500">Materi tidak ditemukan.</div>;
  if (!e) return <div className="container-page py-24 text-center text-slate-400">Memuat…</div>;

  return (
    <div className="container-page py-10 max-w-3xl">
      <Link to="/edukasi" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-brandred mb-6">
        <ArrowLeft className="h-4 w-4" /> Kembali ke Edukasi
      </Link>
      <span className="inline-flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full bg-brandred/10 text-brandred"><Tag className="h-3 w-3" /> {e.category}</span>
      <h1 className="text-3xl font-extrabold text-navy mt-4">{e.title}</h1>
      <div className="flex items-center gap-2 text-sm text-slate-400 mt-3"><Calendar className="h-4 w-4" /> {formatDate(e.date)}</div>
      <img src={e.thumbnail} alt={e.title} className="w-full h-72 object-cover rounded-xl mt-6" />
      <div className="prose-news mt-8 text-[17px]" dangerouslySetInnerHTML={{ __html: e.content }} />
    </div>
  );
}
